import { useDebouncedCallback } from 'use-debounce'

import {
  SpotifyTrack,
  useClearSpotifyTracksMutation,
} from 'src/Redux/spotifyTracksApi'
import { DEBOUNCE_TIMER_1000 } from 'src/Constants/constants'
import { useSearchSpotifyTrack } from 'src/Redux/spotifyTracksApi/useSearchSpotifyTrack'

interface SpotifyWidgetSearchProps {
  onSearchTrack: (searchInput: string) => void
  tracks?: SpotifyTrack[]
  loading?: boolean
  error?: string
}

export const useSpotifyWidgetSearch = (): SpotifyWidgetSearchProps => {
  const { searchTracks, tracks, loading, error, isSuccess } =
    useSearchSpotifyTrack()
  const [clearTracks] = useClearSpotifyTracksMutation()

  const onSearchTrack = useDebouncedCallback((searchInput: string) => {
    if (searchInput) {
      searchTracks(searchInput)
    } else {
      clearTracks()
    }
  }, DEBOUNCE_TIMER_1000)

  const getError = (): string => {
    if (tracks && tracks.length === 0 && isSuccess) {
      return 'No tracks were found'
    }
    return error || ''
  }

  return { onSearchTrack, tracks, loading, error: getError() }
}
